import axios from 'axios';
export default {
  client: function client() {
    return axios.create({
      baseURL: '/api',
      xsrfCookieName: 'XSRF-TOKEN',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache',
        'If-Modified-Since': '0'
      }
    });
  }
};